<template>
  <div>
    <div class="flex flex-between item-center bg">
      <div>
        <el-button type="primary" size="small" @click="toUrl('RedPackageAddAgent')"
        >添加代理商</el-button
        >
      </div>
      <div>
        <el-input
            placeholder="请输入代理商名称"
            class="mr20"
            size="small"
            v-model="searchCondition.storeName"
            clearable>
        </el-input>
        <el-button type="primary" size="small" @click="paging(1)"
        >查询</el-button
        >
      </div>
    </div>
    <hm-content class="mt10">
      <div>
        <el-table
            :data="list"
            border
            stripe
            size="small"
            style="width: 100%">
          <el-table-column
              prop="storeName"
              label="代理商名称"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="serviceType"
              label="类型"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.serviceType === 'enterprise' ? '企业' : '个人'}}
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="加入时间"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="relSupplierNum"
              label="推广供货商数"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              label="操作"
              header-align="center"
              align="center"
              width="240"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="catAuditInfo(scope.row)"
              >查看认证信息</el-button
              >
              <el-button type="text" size="small" @click="toEmployeeManage(scope.row)"
              >员工管理</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div v-if="redPackageDialogVisible">
        <el-dialog
            :title="'认证信息'"
            width="800px"
            :visible.sync="redPackageDialogVisible">
          <HmRedPacgageAudit :auditType="'agent'" :row="row" :formPath="'manage'" :showAudit="false"></HmRedPacgageAudit>
          <!--      <HmRedPacgageAudit :examId="row.examId" :auditType="'agent'" :showAudit="false"></HmRedPacgageAudit>-->
          <div slot="footer" class="dialog-footer flex flex-center mt20">
            <el-button type="primary" size="small" @click="redPackageDialogVisible = false">
              确认</el-button
            >
            <el-button type="info" size="small" @click="redPackageDialogVisible = false">
              取消</el-button
            >
          </div>
        </el-dialog>
      </div>

    </hm-content>
  </div>
</template>

<script>
import HmRedPacgageAudit from "@/components/HmRedPacgageAudit";
export default {
  components: {HmRedPacgageAudit},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        keyWords: "",
        auditState: "agree"
      },
      redPackageDialogVisible: false,
      row: {}
    };
  },
  created() {
    this.queryList();
  },
  mounted() {},
  methods: {
    //员工管理
    toEmployeeManage(row) {
      console.log(row);
     /* this.$router.push({
        name: 'RedPackageAgentEmployeeManage',
        query: {
        id: row.id
        }
      });*/
    },
    //路由跳转
    toUrl(url) {
      this.$router.push({
        name: url
      });
    },
    //查看认证信息
    catAuditInfo(row) {
      this.row = row;
      this.redPackageDialogVisible = true;
    },
    //查询数据
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryRedPackageAgentList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    //修改页数
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    //修改每页条数
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px;
}
</style>
